import { ShieldAlert, ArrowRight } from "lucide-react";
import { Button } from "./Button";

interface PermissionDeniedProps {
  requiredPermission?: string;
  message?: string;
  onContactAdmin?: () => void;
  showContactButton?: boolean;
}

export function PermissionDenied({
  requiredPermission,
  message = "You don't have permission to access this resource.",
  onContactAdmin,
  showContactButton = true,
}: PermissionDeniedProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] px-4">
      <div className="text-center max-w-md">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-50 mb-6">
          <ShieldAlert className="w-8 h-8 text-amber-600" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Access Denied
        </h2>

        <p className="text-gray-600 mb-4">{message}</p>

        {requiredPermission && (
          <div className="mb-6">
            <p className="text-sm font-medium text-gray-700 mb-1">
              Required permission:
            </p>
            <code className="inline-block px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm font-mono">
              {requiredPermission}
            </code>
          </div>
        )}

        {showContactButton && (
          <div className="flex flex-col gap-3">
            {onContactAdmin ? (
              <Button variant="primary" onClick={onContactAdmin}>
                Contact Administrator
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            ) : (
              <p className="text-sm text-gray-500">
                Please contact your system administrator for assistance.
              </p>
            )}

            <Button variant="outline" onClick={() => window.history.back()}>
              Go Back
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
